<div class="mermaid" #mermaid [innerHTML]="svg"></div>

